import * as React from "react";

export type NotificationsContext = {
  watchPriceCheckStatus: (id: string) => void;
};

export const NotificationsContext = React.createContext<NotificationsContext>({
  watchPriceCheckStatus: () => {},
});
